import ScheduleStaffStore from "./ScheduleStaff/ScheduleStaffStore";
import StaffListStore from "./StaffList/StaffListStore";
import TimekeepingStore from "./Timekeeping/TimekeepingStore";
import WorkingScheduleStore from "./WorkingSchedule/WorkingScheduleStore";

export const StaffStore = {
    staffListStore: new StaffListStore(),
    timekeepingStore: new TimekeepingStore(),
    workingScheduleStore: new WorkingScheduleStore(),
    scheduleStaffStore: new ScheduleStaffStore(),
};